define(["require", "exports", "jquery", "../util"], function (require, exports, $, util_1) {
    "use strict";
    exports.__esModule = true;
    function default_1(code, saving, amount, email) {
        var dlgClassName = "signup-coupon-dialog";
        var $dlg = $(dlgClassName);
        var welcomeTitle = 'WELCOME!';
        var welcomeMessagePattern = "We're so glad to have you! Here is the welcome coupon code to take ${{saving}} off your first-time purchase of ${{amount}} or more.";
        var welcomeMessage = util_1.template(welcomeMessagePattern, {
            saving: saving.toFixed(0),
            amount: amount.toFixed(0)
        });
        var welcomeMessageFooter = email ? "We have also sent the code to " + email + ". Please check the junk folder just in case." : '';
        if ($dlg.length === 0) {
            $dlg = $("<div class=\"" + dlgClassName + "\"><h3 class=\"title\">" + welcomeTitle + "</h3><p>" + welcomeMessage + "</p><p class=\"code\">" + code + "</p><p>" + welcomeMessageFooter + "</p><button class=\"email-signup\" type=\"submit\">SHOP NOW</button></div>");
            $dlg.appendTo($('body'));
            $dlg.find('.email-signup').click(function (evt) {
                $dlg.dialog('close');
                window.location.href = '/c/1/luxury-swags-and-tails-valance-curtain-drapes';
            });
        }
        $dlg.dialog('show');
    }
    exports["default"] = default_1;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/dialogs/signupCoupon.js
// module id = 12
// module chunks = 0